import e from "../../node_modules/i18next/dist/esm/i18next.js";
import t from "./en/index.js";
e.init(t);
var n = function n(t, _n) {
  return e.t(t, _n);
};
n.title = function (e, t) {
  return n(e, t).replace(/(^.| .)/g, function (e) {
    return e.toUpperCase();
  });
}, n.sentence = function (e, t) {
  return n(e, t).replace(/^./, function (e) {
    return e.toUpperCase();
  });
}, n.uppercase = function (e, t) {
  return n(e, t).toUpperCase();
};
export { n as t };